import { render, staticRenderFns } from "./lostPublish.vue?vue&type=template&id=9778cbb8&scoped=true&"
import script from "./lostPublish.vue?vue&type=script&lang=js&"
export * from "./lostPublish.vue?vue&type=script&lang=js&"
import style0 from "./lostPublish.vue?vue&type=style&index=0&id=9778cbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9778cbb8",
  null
  
)

export default component.exports